import { SVGProps } from "react";

export const AngleRightIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 11L5.29289 6.70711C5.68342 6.31658 5.68342 5.68342 5.29289 5.29289L1 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>
);
